import { useEffect, useState } from "react";
import { CreateAncestorsLineageForSidePanel } from "@src/cloud-connect/node-manager/entities/create-ancestors-lineage-for-side-panel";
import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";

export const useInitialAncestorsLineageTreeHook = (nodeId) => {
  const initialStructureNodeset = getInitialStructureNodeset();
  const ancestorsLineageCreator = new CreateAncestorsLineageForSidePanel();

  const [initialLocationAncestors, setInitialLocationAncestors] = useState(
    ancestorsLineageCreator.createInitialStructureAncestorsLineageForSidePanel(
      nodeId,
    ),
  );

  useEffect(() => {
    const updateAncestors = () => {
      const updatedAncestors =
        ancestorsLineageCreator.createInitialStructureAncestorsLineageForSidePanel(
          nodeId,
        );
      setInitialLocationAncestors(updatedAncestors);
    };

    // update immediately in case data is already available
    updateAncestors();
    initialStructureNodeset.addObserver(updateAncestors);

    return () => {
      initialStructureNodeset.removeObserver(updateAncestors);
    };
  }, [nodeId, initialStructureNodeset]);

  return initialLocationAncestors;
};
